var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetLimitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 44 44",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.973 14.736a1.46 1.46 0 0 1 1.459 1.46v14.9l3.182-3.17a1.46 1.46 0 0 1 2.06 2.068l-5.996 5.97a1 1 0 0 1-1.412 0l-5.995-5.97a1.46 1.46 0 1 1 2.059-2.067l3.184 3.169v-14.9a1.46 1.46 0 0 1 1.459-1.46m-14.65-6.7a1 1 0 0 1 1.41 0l5.996 5.97a1.46 1.46 0 0 1-2.06 2.067l-3.183-3.17v14.9a1.46 1.46 0 0 1-2.918 0V12.905l-3.182 3.17a1.46 1.46 0 1 1-2.059-2.068z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetLimitIcon);
export default __webpack_public_path__ + "static/media/BetLimitIcon.7ad1de9aea87b821726738deabd6c1fc.svg";
export { ForwardRef as ReactComponent };